
export const otherProjects = [
    {
        link: 'https://dev-caroline-text-to-speech.netlify.app/',
        gitHub: 'https://github.com/devcarolinealmeida/text-to-speech',
        name:'Text to Speech',
        description: 'An application to assist people with language difficulties in expressing themselves.',
        tecnologie: ['JS','Web Speech API' ]
    },
    {
        link: 'https://landingpage-nextjs-sigma.vercel.app/',
        gitHub: 'https://github.com/devcarolinealmeida/landingpage-nextjs',
        name:'Landing Page NextJS',
        description: 'A visually appealing and user-centric landing page. Responsive design and engaging animations to provide a seamless user journey.',
        tecnologie: ['Next.js', 'Framer Motion']
    },
    {
        link: 'https://rock-paper-scissors-swart-gamma.vercel.app/',
        gitHub: 'https://github.com/devcarolinealmeida/rock-paper-scissors',
        name:'Rock Paper Scissors Game',
        description: 'Play against the computer or watch a computer versus computer match.',
        tecnologie: ['CSS3', 'JavaScript']
    },

   
]